export const blackListCenters = [
  { id: "CD12", desc: "SINOP" },
  { id: "CDEN", desc: "MANAUS" },
  { id: "CDIT", desc: "BALSA IT" },
  { id: "CDM1", desc: "MECA/MOISES" },
];
